import { useRouteMatch } from 'react-router-dom';
import { APP_ROLES } from '../constants';

export default function useMenu() {
	const appRoutes = [
		{
			id: 'project',
			title: 'Projects',
			icon: 'home',
			pathname: '/projects',
			active: useRouteMatch('/projects'),
			roles: [APP_ROLES.PARTNER_USER, APP_ROLES.DATACLOUD_USER]
		},
		{
			id: 'template-manager-nav',
			title: 'Template manager',
			icon: 'media-file',
			pathname: '/template-manager',
			active: useRouteMatch('/template-manager'),
			roles: [APP_ROLES.TEMPLATE_ADMIN]
		},
		{
			id: 'roles-nav',
			title: 'Roles',
			icon: 'user-avatar',
			pathname: '/roleManagement',
			active: useRouteMatch('/roleManagement'),
			roles: [APP_ROLES.SUPER_USER]
		},
		{
			id: 'cia-manager-nav',
			title: 'CIA Manager',
			icon: 'action-e-sign',
			pathname: '/ciaManager',
			active: useRouteMatch('/ciaManager'),
			roles: [APP_ROLES.CIA_MANAGER]
		},
		{
			id: 'certificate',
			title: 'Certificate',
			icon: 'action-view-bookmarks',
			pathname: '/certificate',
			active: useRouteMatch('/certificate'),
			roles: [APP_ROLES.PARTNER_USER, APP_ROLES.CERTIFICATE_ADMIN, APP_ROLES.DATACLOUD_USER]
		},
		{
			id: 'members-nav',
			title: 'Members',
			icon: 'user-avatar',
			pathname: '/members',
			active: useRouteMatch('/members'),
			roles: [APP_ROLES.PARTNER_USER, APP_ROLES.DATACLOUD_USER]
		},
		{
			id: 'revShareAdmin',
			title: 'Revenue Share Admin',
			icon: 'payments',
			pathname: '/revShare',
			active: useRouteMatch('/revShare'),
			roles: [APP_ROLES.ACCOUNTS_RECEIVABLE, APP_ROLES.BILLING_ADMIN]
		},
		{
			id: 'revShare',
			title: 'Revenue Share',
			icon: 'payments',
			pathname: '/revShare',
			active: useRouteMatch('/revShare'),
			roles: [APP_ROLES.RS_PARTNER]
		},
		{
			id: 'api-usage',
			title: 'API Usage',
			icon: 'chart-bar',
			pathname: '/api-usage',
			active: useRouteMatch('/api-usage'),
			roles: [APP_ROLES.DATACLOUD_USER]
		},
		{
			id: 'setup',
			title: 'Partner Orgs',
			icon: 'home',
			pathname: '/contacts/partners',
			active: useRouteMatch('/contacts/partners'),
			roles: [APP_ROLES.PARTNER_ADMIN]
		},
		{
			id: 'partner-projects',
			title: 'Partner Projects',
			icon: 'work',
			pathname: '/partner-projects',
			active: useRouteMatch('/partner-projects'),
			roles: [APP_ROLES.PARTNER_ADMIN]
		},
		{
			id: 'accelerator-clients',
			title: 'Accelerator Clients',
			icon: 'ext-mdi-groups',
			pathname: '/accelerator-clients',
			active: useRouteMatch(['/accelerator-clients','/accelerator-projects/:ooid']),
			roles: [APP_ROLES.PARTNER_USER]
		},
		{
			id: 'irec-billing',
			title: 'Billing and Invoice Management',
			icon: 'ledger',
			pathname: '/irec-billing',
			active: useRouteMatch('/irec-billing'),
			roles: [APP_ROLES.FINANCIAL_USER]
		}

	];

	return [{ appRoutes }];
}
